import { ReviewRatingStatistics } from 'shared/types/product/Product';
import { ReviewStats } from 'shared/types/review/Review';

/**
 * Map ReviewRatingStatistics to ReviewStats (or default zeros)
 *
 * @param initialReviewStats Optional stats from product
 */
export function mapReviewStats(initialReviewStats?: ReviewRatingStatistics): ReviewStats {
  if (initialReviewStats) {
    return {
      totalCount: initialReviewStats.count,
      averageRating: initialReviewStats.averageRating,
      ratingDistribution: {
        '5': initialReviewStats.ratingsDistribution['5'] || 0,
        '4': initialReviewStats.ratingsDistribution['4'] || 0,
        '3': initialReviewStats.ratingsDistribution['3'] || 0,
        '2': initialReviewStats.ratingsDistribution['2'] || 0,
        '1': initialReviewStats.ratingsDistribution['1'] || 0,
      },
    };
  }

  return {
    totalCount: 0,
    averageRating: 0,
    ratingDistribution: { '5': 0, '4': 0, '3': 0, '2': 0, '1': 0 },
  };
}
